<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="addserfrm">
        <app-main-heading [title]="this.formTitle"></app-main-heading>
        <div class="productPoup">
            <div class="prodpop-left">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="inputGroupPlan serv">
                            <label for="serviceName" class="inputLabelPlan text000 popInLabel">Service Name</label>
                            <input maxlength="64" type="text"
                                formControlName="productName"
                                class="inputBox {{form.get('productName')?.errors && form.get('productName')?.touched ? 'border-danger' : ''}}"
                                id="serviceName" placeholder="Enter Service Name" />
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('productName')?.hasError('required') && form.get('productName')?.touched">
                                Service Name is required.
                            </small>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('productName')?.hasError('maxlength') && form.get('productName')?.touched">
                                Service name can't be more than
                                {{form.get('productName')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroupPlan">
                            <label for="serreg" class="inputLabelPlan text000 popInLabel">Service Description</label>
                            <textarea id="serreg" formControlName="description" maxlength="80"
                                class="inputBox regTextarea prodModelAreaheight servicelstpopup {{form.get('description')?.errors && form.get('description')?.touched ? 'border-danger' : ''}}"
                                rows="8" placeholder="Enter Service Description"></textarea>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched">
                                Description is required.
                            </small>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('description')?.hasError('maxlength') && form.get('description')?.touched">
                                Description can't be more than
                                {{form.get('description')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Category </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">

                                <mat-select formControlName="categoryId" placeholder="Select Category">
                                    <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                                    <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                                        {{ category.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched">
                                Category is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Sub-Category </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">

                                <mat-select formControlName="subCategoryId" placeholder="Select Sub Category">
                                    <mat-option [value]="" *ngIf="subCategoryList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let subCategory of subCategoryList.response"
                                        [value]="subCategory.id">
                                        {{ subCategory.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched">
                                Sub Category is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="inputGroupPlan">
                            <label for="price" class="inputLabelPlan text000 popInLabel">MRP</label>
                            <input (keypress)="this.allowOnlyNumeric($event)" type="tel" formControlName="price"
                                maxlength="6"
                                class="inputBox {{form.get('price')?.errors && form.get('price')?.touched ? 'border-danger' : ''}}"
                                id="price" placeholder="Enter MRP" />

                            <small class="text-danger errorFixed d-block text-start"
                                *ngIf="form.get('price')?.hasError('required') && form.get('price')?.touched">
                                Price is required.
                            </small>
                            <small class="text-danger errorFixed d-block text-start"
                            *ngIf="form.get('price')?.hasError('min') && form.get('price')?.touched">
                            Price can't be 0.
                        </small>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="inputGroupPlan">
                            <label for="discountedPrice" class="inputLabelPlan text000 popInLabel">Discounted Price
                            </label>
                            <input (keypress)="this.allowOnlyNumeric($event)" type="tel"
                                formControlName="discountedPrice" maxlength="6"
                                class="inputBox {{form.get('discountedPrice')?.errors && form.get('discountedPrice')?.touched ? 'border-danger' : ''}}"
                                id="discountedPrice" placeholder="Enter Discounted Price" />

                            <small class="text-danger errorFixed d-block text-start"
                                *ngIf="form.get('discountedPrice')?.hasError('required') && form.get('discountedPrice')?.touched">
                                Discounted is required.
                            </small>
                            <small class="text-danger d-block text-start"
                            *ngIf="form.get('discountedPrice')?.hasError('moreThanPrice') && form.get('discountedPrice')?.touched">
                            Must be less than MRP.
                        </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="prodpop-right">
                <div class="row">
                    <div class="col-lg-4 col-6">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Service Type </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('serviceTypes')?.hasError('required') && form.get('serviceTypes')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">

                                <mat-select formControlName="serviceTypes" multiple placeholder="Select Service Type">
                                    <mat-option [value]="" *ngIf="servTypeList.loading"><i>Loading ...</i></mat-option>
                                    <mat-option *ngFor="let servicetype of servTypeList.response"
                                        [value]="{id:servicetype.id}">
                                        {{ servicetype.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('serviceTypes')?.hasError('required') && form.get('serviceTypes')?.touched">
                                Service type is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4 col-6">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Appointment </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('appointmentFlag')?.hasError('required') && form.get('appointmentFlag')?.touched ? 'border-danger' : ''}}"
                                appearance="outline">

                                <mat-select formControlName="appointmentFlag" placeholder="Select Appointment">
                                    <mat-option [value]="" *ngIf="appointmentList.loading"><i>Loading
                                            ...</i></mat-option>
                                    <mat-option *ngFor="let appointment of appointmentList.response"
                                        [value]="appointment.id">
                                        {{ appointment.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('appointmentFlag')?.hasError('required') && form.get('appointmentFlag')?.touched">
                                Appointment is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4 col-6">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Status </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('statusId')?.errors && form.get('statusId')?.touched ? 'border-danger' :''}}"
                                appearance="outline">

                                <mat-select formControlName="statusId" placeholder="Select Status">
                                    <mat-option [value]="" *ngIf="statusList.loading"><i>Loading ...</i></mat-option>
                                    <mat-option *ngFor="let status of statusList.response" [value]="status.id">
                                        {{ status.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed d-block text-start"
                                *ngIf="form.get('statusId')?.hasError('required') && form.get('statusId')?.touched">
                                Status is required.
                            </small>
                        </div>
                    </div>
                    <div class="col-lg-4 col-6">
                        <div class="inputGroupPlan">
                            <mat-label class="matLabel text000">Duration </mat-label>
                            <mat-form-field
                                class="w-100 mat-input-group {{form.get('variantOption1')?.errors && form.get('variantOption1')?.touched ? 'border-danger' :''}}"
                                appearance="outline">

                                <mat-select formControlName="variantOption1" placeholder="Select Duration">
                                    <mat-option *ngFor="let duration of serviceDurationList.response"
                                        [value]="duration.name">
                                        {{ duration.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <small class="text-danger errorFixed d-block text-start"
                                *ngIf="form.get('variantOption1')?.hasError('required') && form.get('variantOption1')?.touched">
                                Duration is required.
                            </small>
                        </div>
                    </div>

                    <div class="col-lg-8">
                        <div class="inputGroupPlan">
                            <label for="requirement" class="inputLabelPlan text000 popInLabel">Requirement</label>
                            <input onkeydown="return /[a-z0-9 ]/i.test(event.key)" maxlength="64" type="text"
                                formControlName="requirement"
                                class="inputBox {{form.get('requirement')?.errors && form.get('requirement')?.touched ? 'border-danger' : ''}}"
                                id="requirement" placeholder="Enter Requirement" />

                            <small class="text-danger errorFixed"
                                *ngIf="form.get('requirement')?.hasError('required') && form.get('requirement')?.touched">
                                Requirement is required.
                            </small>
                            <small class="text-danger errorFixed"
                                *ngIf="form.get('requirement')?.hasError('maxlength') && form.get('requirement')?.touched">
                                Requirement can't be more than
                                {{form.get('requirement')?.errors?.['maxlength']?.requiredLength}} chars.
                            </small>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <div class="imgUploadTitle">Upload Product photo</div>
                        <div class="imageUploadSec">

                            <div class="imageUpload foradd me-2" *ngFor="let ml of mediaList?.value; index as k">
                                <label formArrayName="mediaList" class="d-flex justify-content-center" for="sml{{k}}"
                                    class="llb100 {{!ml?.src && k === 0 && form.get('mediaList')?.touched ? 'border-danger' : ''}}">
                                    <input hidden *ngIf="!this.uploadingFile" type="file" id="sml{{k}}"
                                        accept=".png,.jpg,.jpeg" (input)="this.uploadFile($event.target, 'media', k)" />
                                    <div class="uplgimgblk"
                                        *ngIf="!(this.uploadingMediaIndex === k && this.uploadingFile)">
                                        <img src="{{ml?.src}}" *ngIf="ml?.src" alt="" class="imguploded" />
                                        <img src="../../../assets/images/upload-img.svg" *ngIf="!(ml?.src)" alt=""
                                            class="imgdefault" />
                                    </div>
                                    <div *ngIf="this.uploadingMediaIndex === k">
                                        <div class="loader"></div>
                                    </div>
                                </label>
                                <button class="imgdel" *ngIf="ml?.src" (click)="this.removeMedia(k)">
                                    <img src="./assets/images/trash-icon.svg" alt="" />
                                </button>
                            </div>

                        </div>
                        <div class="imgUploadText">
                            *Recommended resolution is 640×640 with file size {{this.allowedFileSizeToUpload}} MB
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <div class="btnbx modPopBtns mt-5">
                <button type="button" [disabled]="this.submitLoading || this.uploadingFile"
                    class="btnThemeOutline blue me-3 modelPopup-btn" (click)="this.handleReset()">
                    Cancel
                </button>
                <button class="gredientOutLineBtn" [disabled]="this.submitLoading || this.uploadingFile">
                    <!-- <div class="loader" *ngIf="this.submitLoading"></div>
                    <div class="btnContent modelPopup-btn" *ngIf="!this.submitLoading">Add New Service </div> -->
                    <div class="btnContent modelPopup-btn">
                        <div class="loader small" *ngIf="this.submitLoading"></div>
                        <div *ngIf="!this.submitLoading">Add New Service</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</form>